<template>
  <div class="category inline-block">
    <div v-for="(item, index) in lists" :key="index">
      <!-- <div class="title" :ref="'Card_' + index" v-if="item.id==1" @click="jumpToCum" type="info" style="cursor:hand;cursor: pointer;margin-top: 40px;">
        {{ item.name }}
      </div> -->
      <!-- v-else="item.id!=1" -->
      <div class="title":ref="'Card_' + index" v-if="item.id != 1" @mouseover="showCard(index)" @mouseleave="hiddenCard(index)" style="margin-top: 10px;">
        {{ item.name }}
      </div>
      <div
        class="subCard"
        :ref="'subCard_' + index"
        @mouseover="showCard(index)"
        @mouseleave="hiddenCard(index)"
      >
        <div v-for="(element, inx) in item.childrens" :key="inx">
          <div class="sub">
            <div>
              <div class="subTitle">
                {{ element.name }}
                <i
                  style="color: #666; font-weight: 900"
                  class="el-icon-arrow-right"
                ></i>
              </div>
            </div>
            <div class="thirdChild">
              <div v-for="(e, i) in element.childrens" :key="i">
                <el-link type="info" :underline="false" @click="catelogIndex(e.id)">{{ e.name }}</el-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div >
      <el-dialog title="定制商品" :visible.sync="dialogFormVisible">
        <el-form :model="customForm" :rules="rules" ref="customForm">
          <el-form-item label="收货地址:" :label-width="formLabelWidth">
            <!-- <el-card shadow="never"> -->
            <div>
              <el-radio-group v-model="radio">
                <div class="selectItem" v-if="address.length>0" v-for="(item, index) in address" :key="index" >
                  <el-radio :label="index">
                    <span>{{ item.detailedAddress }}</span>
                    <span> ({{ item.name }} 收) </span>
                    <span> {{ item.mobile }}</span>
                    <span v-if="item.isDefault">(默认)</span>
                    <!-- <el-button icon="el-icon-delete" type="mini" @click="delAdress(item.id)">删除</el-button> -->
                  </el-radio>
                </div>
                 <div class="selectItem" v-if="address.length === 0">
                   <el-button class="el-icon-help">请到个人中心添加收货地址</el-button>
                 </div>
              </el-radio-group>
            </div>
          <!-- </el-card> -->
          </el-form-item>
          <el-form-item label="产品名称:" :label-width="formLabelWidth" prop="getProjectName">
            <el-input v-model="customForm.getProjectName" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="产品类型:" :label-width="formLabelWidth" prop="indexCategoryValue">
            <el-select v-model="customForm.indexCategoryValue" :clearable="true" placeholder="请选择类型" >
              <el-option v-if="item.id !=1" v-for="item in categoryData" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品需求描述:" :label-width="formLabelWidth" prop="productDescrible">
            <el-input type="textarea" v-model="customForm.productDescrible"></el-input>
          </el-form-item>
          <el-form-item label="产品数量:" :label-width="formLabelWidth" prop="productNumber">
             <el-input-number v-model="customForm.productNumber" :min="1" :max="100000" label="描述文字"></el-input-number>
          </el-form-item>
          <el-form-item label="是否需要证书:" :label-width="formLabelWidth">
            <el-switch v-model="customForm.isNeedCert" active-value="1" inactive-value="0"></el-switch>
          </el-form-item>
          <el-form-item label="交货周期:" :label-width="formLabelWidth" prop="deliveryCycle">
            <el-input type="textarea"   placeholder="请输入交货周期（200字以内）" maxlength="200" v-model="customForm.deliveryCycle"></el-input>
          </el-form-item>
          <el-form-item label="价格需求:" :label-width="formLabelWidth" prop="priceNeed">
             <el-input v-model="customForm.priceNeed" :min="0.01" :max="1000000" label="描述文字"></el-input>
          </el-form-item>
          <el-form-item label="预计年需求量:" :label-width="formLabelWidth" prop="yearRequimentNumber">
             <el-input-number v-model="customForm.yearRequimentNumber" :min="1" :max="1000000" label="描述文字"></el-input-number>
          </el-form-item>
          <el-form-item>
              <el-upload list-type="picture-card" action="" :http-request="HandleHttpRequest" :on-remove="handleRemove" ref="upload">
                <i class="el-icon-plus"></i>
              </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <!-- <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button> -->
          <el-button @click="resetForm('customForm')" >取 消</el-button>
          <el-button type="primary" @click="submitCustom('customForm')">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
// import lists from './category.config';
import { adressList } from '@/api/adress/adress';
import { getCategoryList } from '@/api/category/category';
import { addCustomize,uploadFile } from '@/api/order/order';

export default {
  name: 'Category',
  data() {
    return {
      // lists,
      lists: [],
      radio: 0,
      form: [],
      categoryData: [],
      dialogFormVisible: false,
      formLabelWidth: '120px',
      address: [],
      picUrls: new Array(),
      customForm: {
        getProjectName: '',
        productDescrible: '',
        productNumber: 100,
        indexCategoryValue: '',
        isNeedCert: '0',
        deliveryCycle: '',
        priceNeed: '100',
        yearRequimentNumber: '10000',
        dialogImageUrl: '',
      },
      rules: {
        // 要以数组形式展示
        getProjectName: [
          { required: true, message: '姓名不能为空', trigger: 'blur' },
          { min: 2, max: 25, message: '长度在 2 到 25 个字符', trigger: 'change',},
        ],
        indexCategoryValue: [
          { required: true, message: '产品类型必填', trigger: 'change' },
        ],
        deliveryCycle: [
          { required: true, message: '交货周期必填', trigger: 'blur' },
        ],
        productNumber: [
          { required: true, message: '产品数量必填', trigger: 'blur' },
        ],
        productDescrible: [
          { required: true, message: '产品需求描述不能为空', trigger: 'blur' },
        ],
        priceNeed: [
          { required: true, message: '价格需求不能为空', trigger: 'blur' },
        ],
        yearRequimentNumber: [
          { required: true, message: '年需求不能为空', trigger: 'blur'},
        ],
      },
    };
  },
  created() {
    this.getCategoryList();
  },
  mounted() {
    // this.getAdressList();
  },
  methods: {
    jumpToCum(){
      let userInfo = this.$store.state.userInfo;
      if (userInfo === null) {
        this.$message({
          showClose: true,
          message: '尊敬的用户，请您先完成登录!',
          type: 'info',
        });
        this.$router.push('/PC/login?isLogin=true');
      } else {
         this.dialogFormVisible = true;
         this.getAdressList();
      }
    },
    //上传图片
    HandleHttpRequest(a){
      var formData = new FormData();
      formData.append('file',a.file);
      uploadFile(formData).then(res=>{
        if(res.errno == 0){
          if(this.picUrls == ''){
            this.picUrls = new Array();
          }
          this.picUrls.push(res.data.url);
          this.$emit('on-success', res.url) // 返回图片的存储路径
        }else{
          this.$message({ type: 'error', message: res.errmsg });
        }
      });
    },
    //删除方法
    handleRemove(name, file ,fileList) {
      if(this.picUrls != ''){
        this.picUrls.pop(file);
      }
    },
    resetForm(formName) {
        this.$refs[formName].resetFields();
        this.$refs.upload.clearFiles();
        this.picUrls = '';
        this.dialogFormVisible = false;
    },
    submitCustom(formName) {
      var picString = "";
        if(this.picUrls != null && this.picUrls.length > 0){
          picString = this.picUrls.join(',');
      };
      if(this.address[this.radio] == undefined){
        this.$message({ type: 'error', message: "未找到收货地址,请先添加收货地址" });
        return ;
      }
      var params = {
        productType: this.customForm.indexCategoryValue,
        describe: this.customForm.describe,
        num: this.customForm.productNumber,
        isCertificate: this.customForm.isNeedCert,
        period: this.customForm.deliveryCycle,
        price: this.customForm.priceNeed,
        annualDemand: this.customForm.yearRequimentNumber,
        sample: picString,
        addressId: this.address[this.radio].id,
        projectName: this.customForm.getProjectName,
      };
      this.$refs[formName].validate(valid => {
        if(valid){
          addCustomize(params)
            .then(res => {
              if (res.errno == 0) {
                this.$message({ type: 'success', message: '定制订单提交成功，感谢您的支持！'});
                this.resetForm("customForm");
                this.$router.push('/PC/index');
              } else {
                this.$message({ type: 'error', message: res.errmsg });
              }
            })
          // .catch(res => {
          //     this.$message({ type: 'info',message: '提交订单失败' });
          // });
        }
      });
    },
    //收货地址
    getAdressList() {
      adressList().then((response) => {
        var data = response.data;
        this.address = data;
        if(response.errno == 501){
          this.$message({
            showClose: true,
            message: '尊敬的用户，请您先完成登录!',
            type: 'info',
          });
          this.$router.push('/PC/login?isLogin=true');
        }else{
          if(data.length>0){
          var radioindex = this.radio;
          data.forEach(function (item, index) {
            if (item.isDefault) {
              radioindex = index;
            }
          });
          this.radio = radioindex;
        }
        }
      });
    },
    //跳转页面
    catelogIndex(id) {
      if(id == 75 && this.$store.state.userInfo.type == 2){
        this.$router.push({ path: '/PC/harmfulCustomize/'});
      } else{
        const query = { categoryId: id, page: 1, size: 10 };
        this.$router.push({ path: '/PC/search/', query: query });
      }
    },
    showCard(index) {
      // console.log('显示的是 ' + index);
      this.$refs['subCard_' + index][0].classList.add('active');
      this.$refs['Card_' + index][0].classList.add('active');
    },
    hiddenCard(index) {
      // console.log('隐藏的是 ' + index);
      this.$refs['subCard_' + index][0].classList.remove('active');
      this.$refs['Card_' + index][0].classList.remove('active');
    },
    getCategoryList() {
      getCategoryList().then((response) => {
        var allList = response.data.allList;
        var categoryList = response.data.categoryList;
        this.categoryData = categoryList;
        var type = this.$store.state.userInfo.type;
        categoryList.forEach((v, index) => {
          if (v.id != 1) {
            for (var i in allList) {
              if (v.id == i) {
                let arr = new Array();
                arr.push(JSON.parse(JSON.stringify(v)));
                allList[i].forEach(function (item, index) {
                  if (item.name == '定制') {
                    allList[i].splice(index, 1);
                  }
                });
                v.childrens = arr;
                v.childrens[0].childrens = allList[i];
              }
            }
          }
        });
        // categoryList.splice(0,1);
        this.lists = categoryList;
        // console.log(JSON.stringify(categoryList));
      });
    },
  },
};
</script>

<style scoped>
.category {
  box-sizing: border-box;
  width: 90px;
  height: 470px;
  background: #fff;
  position: relative;
  padding: 20px 0;
  top: 0;
  left: 0;
  font-size: 14px;
}

.category .title {
  width: 100%;
  padding: 7px 18px;
  padding-left: 12px;
}

.subCard {
  display: none;
  position: absolute;
  top: 0;
  left: 90px;
  z-index: 1000;
  width: 300px;
  height: 450px;
  background: #fff;
  box-shadow: #bbb 0px 0px 10px;
}

.title.active {
  display: block;
  background: #eee;
}

.active {
  display: block;
}

.title_active {
  color: #666;
  background: #d9d9d9;
}

.subCard {
  padding: 10px 0;
}

.sub {
  display: flex;
  margin: 12px 0;
}

.subTitle {
  font-size: 14px;
  color: #333;
  font-weight: 600;
  width: 90px;
  text-align: right;
}

.thirdChild {
  display: flex;
  flex-wrap: wrap;
  color: #666;
}

.thirdChild div {
  padding: 0 4px;
}
</style>



// WEBPACK FOOTER //
// src/views/PC/category/Category.vue